<div
    class="{{ 'dropdown-menu-wrapper ' + theme() }}"
    [class.selected]="showMenu"
    [class.show]="alwaysShow()"
    [class.use-box-shadow]="useBoxShadow()"
    (clickOutside)="closeMenu()"
>
    @if (asDotted()) {
        <div class="dotted-menu" (click)="openMenu()"></div>
    }
    @if (!asDotted()) {
        <div class="selection-box" [class.dynamic-height]="dynamicHeight()" (click)="openMenu()">
            <div class="header" [class.hide]="!showHeader()">{{ header() }}</div>
            <div class="selected-option-container">
                <div class="selected-option-container__text">
                    {{ selectedItem?.maintext }}
                    @if (selectedItem?.subtext && showSubInSelected()) {
                        <ng-container> &nbsp; {{ selectedItem?.subtext }} </ng-container>
                    }
                </div>
                <div class="selected-option-container__arrow"></div>
            </div>
        </div>
    }
    @if (items() && items().length > 0) {
        <div #dropDownMenu class="items-wrapper" [style.right]="right()" [style.top]="top()" [class.show]="showMenu" [class.from-right]="fromRight()">
            <div class="items-wrapper__header" (click)="closeMenu()"></div>
            @for (item of items(); track $index; let i = $index) {
                <div class="items-wrapper__item" [class.selected]="item.isSelected" (click)="setSelected(item.key)">
                    <div class="items-wrapper__item__main-text">
                        {{ item.maintext }}
                    </div>
                    @if (item.subtext) {
                        <div class="items-wrapper__item__sub-text">
                            {{ item.subtext }}
                        </div>
                    }
                </div>
            }
        </div>
    }
</div>
